@import "../../../../../shared/styles/base";
@import "../../../../../shared/components/design-system/Button/styles//surfaces";

.Container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  padding: 0 $page-margin-mobile;
  max-width: calc(var(--design-width, 1136px) + $page-margin-mobile * 2);
  width: 100%;
  @include grey-surface;

  &.x-small {
    --design-width: 368px;
  }

  &.small {
    --design-width: 560px;
  }

  &.medium {
    --design-width: 752px;
  }

  &.large {
    --design-width: 944px;
  }

  &.max {
    --design-width: 1136px;
  }

  @media screen and (min-width: $tablet) {
    padding: 0 $page-margin;
    max-width: calc(var(--design-width, 1136px) + $page-margin * 2);
  }
}
